// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4826a226","732":"357ae607","977":"87e1b2a3"}[chunkId] + ".chunk.js";
};